import { useLocale } from "../i18n/useLocale.js";
import { Modal } from "./Modal";

export function ConfirmDialog({
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
}) {
  const { display } = useLocale();

  return (
    <Modal title={title} onClose={onCancel}>
      <p className="confirm-dialog-message">{message}</p>
      <div className="modal-actions">
        <button type="button" className="secondary-button" onClick={onCancel}>
          {cancelLabel ?? display.t("common.cancel")}
        </button>
        <button type="button" className="primary-button confirm-dialog-confirm" onClick={onConfirm}>
          {confirmLabel ?? display.t("web.confirm.confirm")}
        </button>
      </div>
    </Modal>
  );
}
